
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 3h20v26H5V3zm2 2v22h16V5H7zm8 4.719l5.25 1.313-.5 1.938-2.75-.688v6.719c0 1.645-1.355 3-3 3s-3-1.355-3-3 1.355-3 3-3c.353 0 .684.073 1 .188V9.72zM14 18c-.564 0-1 .436-1 1s.436 1 1 1 1-.436 1-1-.436-1-1-1z"}})])
          )
        }
      }
    